import { BlogPost } from "@/lib/blog";

export const EN_KEYWORDS = ["Organizational Development", "Agile", "COO", "Operations", "Operational Excellence", "Heilbronn", "Neuenstadt", "Neckarsulm", "Öhringen", "Systemic Consulting"];
export const DE_KEYWORDS = ["Organisationsentwicklung", "Agile", "COO", "Operations", "Operational Excellence", "Heilbronn", "Neuenstadt", "Neckarsulm", "Öhringen", "Systemische Beratung"];

export const getKeywordsForPost = (post: BlogPost) => {
  const defaultKeywords = post.language === 'de' ? DE_KEYWORDS : EN_KEYWORDS;

  // Combine defaults, explicit tags, and title words, then deduplicate
  return Array.from(new Set([
    ...defaultKeywords,
    ...(post.tags || []),
    ...post.title.split(" ").filter(w => w.length > 3)
  ]));
};
